import { COLORS, FONTS, SIZE } from '@app/src/ui';
import styled from 'styled-components';
import { withShimmer } from '@app/src/common/withShimmer';

const ROOT = 'MyPackage/listMyPackage/ListMyPackage';

export const Container = styled.div`
  padding: 25px 15px 0;
  max-width: 815px;
  margin: 0 auto;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    padding: 0;
  }
`;

Container.className = `${ROOT}/Container`;

export const TotalAvailable = styled.span`
  color: ${COLORS.BLUE_LINK};
  margin-left: 15px;
`;

TotalAvailable.className = `${ROOT}/TotalAvailable`;

export const ListPackage = styled.ul``;

ListPackage.className = `${ROOT}/ListPackage`;

export const Disclaimer = styled.p`
  font-family: ${FONTS.ROBOTO};
  color: ${COLORS.GRAY_TEXT};
  margin-bottom: 8px;
`;

Disclaimer.className = `${ROOT}/Disclaimer`;

export const DisclaimerWrapper = styled.div`
  margin-bottom: 50px;
`;

DisclaimerWrapper.className = `${ROOT}/DisclaimerWrapper`;

export const Item = styled.li`
  margin-bottom: 15px;
`;

Item.className = `${ROOT}/Item`;

export const ButtonBack = styled.a`
  margin: 30px 15px 0;
  display: inline-block;
  font-family: ${FONTS.ROBOTO_BOLD};
  font-size: 15px;
  display: flex;
  cursor: pointer;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    margin: 45px 0 0 56px;
  }
`;

ButtonBack.className = `${ROOT}/ButtonBack`;

export const IconBack = styled.span`
  margin-right: 12px;
`;

IconBack.className = `${ROOT}/IconBack`;

export const OptionShimmer = styled.div`
  &:not(last-child) {
    margin-bottom: 11px;
  }
`;

export const TitleShimmer = styled.div`
  width: 185px;
  height: 25px;
`;

export const DescriptionShimmer = styled.div`
  height: 336px;
  margin-top: 8px;
  width: 100%;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    height: 136px;
  }
`;

export const WrapperShimmer = styled.div`
  min-height: 50px;
  width: 100%;
`;

export const Shimmer = withShimmer()(styled.div``);